/* MA Wishlist -- client-side toggle with localStorage persistence */

/* Normalize any product URL to /products/handle
   Strips collection prefix, query params, hash -- ensures consistent
   matching regardless of where the heart was clicked (collection vs search vs PDP) */
function maUrlNorm(url) {
  var m = String(url).match(/\/products\/([^/?#]+)/);
  return m ? '/products/' + m[1] : String(url).split('?')[0];
}

/* Toast -- confirms save and surfaces localStorage errors */
function maWishToast(msg) {
  var t = document.createElement('div');
  t.textContent = msg;
  t.style.cssText = [
    'position:fixed',
    'bottom:28px',
    'left:50%',
    'transform:translateX(-50%)',
    'background:#404040',
    'color:#fff',
    'padding:10px 22px',
    'font-family:Barlow,sans-serif',
    'font-size:13px',
    'letter-spacing:0.06em',
    'text-transform:uppercase',
    'z-index:9999',
    'pointer-events:none',
    'border-radius:3px',
    'white-space:nowrap',
    'opacity:1',
    'transition:opacity 0.4s'
  ].join(';');
  document.body.appendChild(t);
  setTimeout(function() {
    t.style.opacity = '0';
    setTimeout(function() { if (t.parentNode) t.parentNode.removeChild(t); }, 400);
  }, 2000);
}

function maToggleWish(btn, url) {
  if (!url) return;
  url = maUrlNorm(url); /* always store normalized /products/handle form */
  var adding;
  try {
    var list = JSON.parse(localStorage.getItem('ma-wishlist') || '[]');
    var normList = list.map(maUrlNorm);
    var idx = normList.indexOf(url);
    if (idx === -1) { list.push(url); adding = true; }
    else            { list.splice(idx, 1); adding = false; }
    localStorage.setItem('ma-wishlist', JSON.stringify(list));
    btn.classList.toggle('is-wishlisted', adding);
    maWishToast(adding ? 'Added to wishlist' : 'Removed from wishlist');
  } catch(e) {
    btn.classList.toggle('is-wishlisted');
    maWishToast('Wishlist unavailable in this browser');
  }
}

/* Initialize / refresh wishlisted state on all heart buttons in the DOM.
   Called on page load AND after Dawn's facets.js replaces the grid via AJAX.
   Normalizes both stored URLs and button data-url before comparing -- fixes
   mismatches between collection-prefixed URLs and /products/handle form. */
function maInitWishBtns() {
  try {
    var list = JSON.parse(localStorage.getItem('ma-wishlist') || '[]');
    var normList = list.map(maUrlNorm);
    document.querySelectorAll('.ma-card__wish[data-url]').forEach(function(btn) {
      var normUrl = maUrlNorm(btn.dataset.url);
      btn.classList.toggle('is-wishlisted', normList.indexOf(normUrl) !== -1);
    });
  } catch(e) {}
}

document.addEventListener('DOMContentLoaded', function() {
  maInitWishBtns();

  /* Watch #product-grid for DOM changes (facets AJAX, search filters, pagination)
     and re-initialize hearts whenever new cards are inserted */
  var grid = document.getElementById('product-grid');
  if (grid) {
    new MutationObserver(function() { maInitWishBtns(); })
      .observe(grid, { childList: true, subtree: true });
  }
});
